module.exports = __webpack_public_path__ + "370598a1ea77d7be9014609e154e7ca4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/examples-1.png
// module id = 1718
// module chunks = 0